export const addSelectionOptionsToMenuItem = (item, options) => {
    const menuSelectionItemOptionsByMicoId = options.reduce((mapping, o) => {
        return {
            ...mapping,
            [o.menuItemChoiceOption.id]: o,
        };
    }, {});
    return {
        ...item,
        choices: item.choices.map(({ options, ...c }) => ({
            ...c,
            options: options.map((o) => {
                const selectionItemOption = menuSelectionItemOptionsByMicoId[o.id];
                return {
                    ...o,
                    menuSelectionItemOption: selectionItemOption
                        ? { amount: selectionItemOption.amount, percentConsumed: selectionItemOption.percentConsumed }
                        : null,
                };
            }),
        })),
    };
};
export const getMenuItemOptionErrors = (menuItem) => {
    return menuItem.choices.reduce((errors, c) => {
        const optionsForChoiceCount = c.options.filter(o => o.menuSelectionItemOption !== null).length;
        if (c.required && optionsForChoiceCount === 0) {
            return [...errors, `'${c.name}' choice is required`];
        }
        if (c.maxOptionsCount && optionsForChoiceCount > c.maxOptionsCount) {
            return [...errors, `Only ${c.maxOptionsCount} choice(s) allowed for '${c.name}'`];
        }
        return errors;
    }, []);
};
/**
 * Returns the maxAmount of a MenuItem that may be set when adding or editing an selection.
 * Considers both MenuItemAppearance.maxAmount and MealMenuDiningStation.maxAmount constraints, using most strict existing value
 *
 * Note: menuSelectionItemAmount is added to the maxAmount total because an existing MenuSelectionItem's amount should already
 * be counted in each of the currentAmount inputs
 */
export const getMenuItemMaxAmount = ({ currentAmountForMenuSection, maxAmountForMenuSection, currentAmountForMenuItem, maxAmountForMenuItem, menuSelectionItemAmount = 0, }) => {
    let remaining;
    if (maxAmountForMenuItem !== null && maxAmountForMenuSection !== null) {
        const remainingForMenuItem = maxAmountForMenuItem - currentAmountForMenuItem;
        const remainingForMenuSection = maxAmountForMenuSection - currentAmountForMenuSection;
        remaining = Math.min(remainingForMenuItem, remainingForMenuSection);
    }
    else if (maxAmountForMenuItem !== null) {
        remaining = maxAmountForMenuItem - currentAmountForMenuItem;
    }
    else if (maxAmountForMenuSection !== null) {
        remaining = maxAmountForMenuSection - currentAmountForMenuSection;
    }
    else {
        remaining = null;
    }
    if (remaining === null) {
        return null;
    }
    else {
        return Math.max(0, remaining + menuSelectionItemAmount);
    }
};
export const getMenuSectionAmountsForMenuItem = (menuItemId, menuSections, menuSectionAmounts) => {
    const matchingMenuSection = menuSections.find(({ menuItemAppearances }) => menuItemAppearances.map(mia => mia.menuItem.id).includes(menuItemId));
    const currentAmountForMenuSection = (matchingMenuSection && menuSectionAmounts[matchingMenuSection.id]) || 0;
    return {
        currentAmountForMenuSection,
        maxAmountForMenuSection: matchingMenuSection?.maxAmount || null,
    };
};
//# sourceMappingURL=utils.js.map